import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { ModuleData, ModuleProgress } from '../../types';
import { Card } from '../ui/Card';
import { Layers, Play, Sprout } from 'lucide-react';
import * as Icons from 'lucide-react';
import { Button } from '../ui/Button';
import { GroupId } from '../../config/systemConfig';
import { getModuleDisplayInfo } from '../../config/moduleContent';
interface ModuleCardNewProps {
  module: ModuleData;
  progress?: ModuleProgress; // Made optional to handle undefined case safely
  onClick: () => void;
  selectedGroup: GroupId;
}
export function ModuleCardNew({
  module,
  progress,
  onClick,
  selectedGroup
}: ModuleCardNewProps) {
  // Safe progress access - CRITICAL FIX
  const safeProgress = progress || {
    subSkills: {},
    masteryPercentage: 0,
    questionsAnswered: [],
    recentQuestions: [],
    reviewNeededCount: 0,
    cheatSheetViewed: false,
    masteryByDifficulty: {},
    status: 'learning' as const
  };
  const IconComponent = (Icons as any)[module.icon] || Icons.HelpCircle;
  // Get dynamic content based on group
  const displayInfo = getModuleDisplayInfo(module.id, selectedGroup);
  const title = displayInfo?.title || module.title;
  const description = displayInfo?.description || module.description;
  // Calculate active skills (growth metric)
  const subSkills = safeProgress.subSkills || {};
  const activeSkills = Object.values(subSkills).length;
  const masteringSkills = Object.values(subSkills).filter(s => s.masteryScore >= 85 && s.questionsAnswered >= 5).length;
  const isStarted = activeSkills > 0;
  // Derive background color from text color class (e.g., text-blue-500 -> bg-blue-50)
  const bgColorClass = module.color.replace('text-', 'bg-').replace('500', '50');
  return <motion.div whileHover={{
    y: -4
  }} transition={{
    type: 'spring',
    stiffness: 300,
    damping: 20
  }} className="h-full" data-id="element-402">
      <Card className="h-full flex flex-col p-0 overflow-hidden border-slate-200/60 transition-all duration-300 group cursor-pointer hover:border-indigo-200 hover:shadow-lg" onClick={onClick} data-id="element-403">
        <div className="p-5 flex-1 flex flex-col" data-id="element-404">
          <div className="flex justify-between items-start mb-4" data-id="element-405">
            <div className={`p-3 rounded-xl ${bgColorClass} transition-transform group-hover:scale-110 duration-300`} data-id="element-406">
              <IconComponent className={`w-6 h-6 ${module.color}`} data-id="element-407" />
            </div>

            {isStarted && <span className="text-[10px] font-bold uppercase tracking-wider px-2 py-1 rounded-lg bg-indigo-50 text-indigo-600 flex items-center gap-1" data-id="element-408">
                <Sprout className="w-3 h-3" data-id="element-409" />
                {activeSkills} skills
              </span>}
          </div>

          <h3 className="text-lg font-bold text-slate-900 mb-2 group-hover:text-indigo-600 transition-colors" data-id="element-410">
            {title}
          </h3>
          <p className="text-sm text-slate-500 line-clamp-2 mb-4 flex-1" data-id="element-411">
            {description}
          </p>

          <div className="flex items-center gap-1.5 text-xs text-slate-400 font-medium mt-auto" data-id="element-412">
            <Layers className="w-3.5 h-3.5" data-id="element-413" />
            <span data-id="element-414">Groep 6 • 7 • 8</span>
          </div>
        </div>

        {/* Growth Section */}
        <div className="px-5 pb-5 mt-auto" data-id="element-415">
          {isStarted ? <div className="space-y-2" data-id="element-416">
              <div className="flex justify-between text-xs font-medium text-slate-500" data-id="element-417">
                <span data-id="element-418">Groei</span>
                <span className="text-indigo-600 font-bold" data-id="element-419">
                  {masteringSkills} beheerst
                </span>
              </div>
              <div className="flex gap-1 h-1.5 bg-slate-100 rounded-full overflow-hidden" data-id="element-420">
                {Object.values(subSkills).length > 0 ? Object.values(subSkills).slice(0, 5).map((skill, i) => <div key={i} className={`flex-1 ${skill.masteryScore >= 85 ? 'bg-emerald-500' : skill.masteryScore >= 60 ? 'bg-indigo-500' : skill.masteryScore >= 30 ? 'bg-teal-400' : 'bg-slate-300'}`} data-id="element-421" />) : <div className="w-full bg-slate-200" data-id="element-422" />}
              </div>
            </div> : <div className="text-xs text-slate-400 italic flex items-center gap-2" data-id="element-423">
              <div className="w-1.5 h-1.5 rounded-full bg-slate-300" data-id="element-424" />
              Nog niet gestart
            </div>}

          <div className="h-0 overflow-hidden group-hover:h-auto group-hover:mt-4 transition-all duration-300 opacity-0 group-hover:opacity-100" data-id="element-425">
            <Button size="sm" fullWidth variant="primary" className="mt-2" data-id="element-426">
              <Play className="w-3 h-3 mr-2 fill-current" data-id="element-427" />
              {isStarted ? 'Verder Oefenen' : 'Starten'}
            </Button>
          </div>
        </div>
      </Card>
    </motion.div>;
}